export default __webpack_public_path__ + "static/media/Kollektiv35_StimmeX_Web-40.51ffddf2.jpg";